<!--
 * @Author: 范向玲
 * @Date: 2022-12-08 13:42:21
 * @LastEditTime: 2022-12-08 13:42:21
 * @LastEditors: 范向玲
 * @Description: 全球矿业资源信息系统大屏数据管理—国内外大型矿业公司
 * @FilePath: \src\views\DataManager\ScreenManager.vue
-->
<template>
  <section class="trend-situation">
    <a-tabs v-model:activeKey="activeKey" class="trend-situation-tabs">
      <a-tab-pane v-for="item in tabsList" :key="item.key" :tab="item.name" v-bind="item.option">
        <component :is="item.component"></component>
      </a-tab-pane>
    </a-tabs>
  </section>
</template>

<script setup>
import { onMounted, ref, reactive, getCurrentInstance, } from 'vue';
import config from '@/config/config';
import DataManager from '@/components/DataManager/MiningCompany/index.vue';
const activeKey = ref('1');

const tabsList = [
  {
    key: '1',
    name: '全球矿业资源信息系统大屏数据管理—国内外大型矿业公司',
    option: {
      forceRender: true,
    },
    component: DataManager,
  },
];

</script>

<style lang='scss'>
.trend-situation {
  background-color: rgba(179, 150, 92, 0.05);
  height: 100%;

  /* tabs */
  .trend-situation-tabs {
    height: 100%;

    /* 头 */
    .ant-tabs-top-bar {
      height: 0.5rem;
    }

    /* 内容区 */
    .ant-tabs-content {
      height: calc(100% - 0.5rem);

      .ant-tabs-tabpane {
        height: 100%;
      }
    }

    .ant-tabs {
      overflow: inherit;
    }

    .ant-tabs-nav-container {
      // background-color: rgba(10, 7, 0, 0.4);
    }
    .ant-tabs-ink-bar {
      background-color: transparent;
    }
    .ant-tabs-nav {
      .ant-tabs-tab:active {
        color: #fff;
        background-color: rgba(43, 34, 8, 0.7);
      }
      .ant-tabs-tab:hover {
        color: #fff;
        background-color: rgba(43, 34, 8, 0.7);
      }
    }
    .ant-tabs-bar {
      margin: 0;
      border-bottom: none;

      .ant-tabs-tab {
        color: rgba(255, 255, 255, 0.6);
        font-size: 0.16rem;
      }

      .ant-tabs-tab-active {
        color: #fff;
      }
    }
  }
}
</style>